/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../../wire/ApiCaller";
import type {
  CanConnectResponse,
  CheckAllJiraProjectPermissionsForArtRequest,
  CheckAllJiraProjectPermissionsForArtResponse,
  CheckJiraIssueTypeFieldsRequest,
  CheckJiraIssueTypeFieldsResponse,
  CheckJiraIssueTypeForArtsRequest,
  CheckJiraIssueTypeForArtsResponse,
  CheckJiraLinkTypeRequest,
  CheckJiraLinkTypeResponse,
  CheckJiraProjectPermissionsForArtResponse,
  CheckJiraProjectPermissionsResponse,
  CheckJiraTeamMappingsRequest,
  CheckJiraTeamMappingsResponse,
  CreateJiraSyncSessionRequest,
  CreateJiraSyncSessionResponse,
  CreateJiraTestIssueFromClientFormatRequest,
  CreateJiraTestIssueRequest,
  CreateJiraTestIssueResponse,
  FinishJiraOAuthRequest,
  GetJiraArtFieldMappingFormattedResponse,
  GetJiraArtFieldMappingResponse,
  GetJiraArtTeamFieldMappingFieldsRequest,
  GetJiraArtTeamFieldMappingFieldsResponse,
  GetJiraArtTeamFieldMappingFormattedResponse,
  GetJiraArtTeamFieldMappingResponse,
  GetJiraAuthMethodResponse,
  GetJiraBoardMappingResponse,
  GetJiraCustomEpicIssueTypeResponse,
  GetJiraEpicIssueTypeResponse,
  GetJiraFieldsRequest,
  GetJiraFieldsResponse,
  GetJiraIssueLinkTypesResponse,
  GetJiraIssueTypesRequest,
  GetJiraIssueTypesResponse,
  GetJiraKanbanBoardResponse,
  GetJiraKanbanConfigsRequest,
  GetJiraKanbanConfigsResponse,
  GetJiraOAuthConsumerKeyResponse,
  GetJiraOAuthPublicKeyResponse,
  GetJiraOAuthUrlRequest,
  GetJiraOAuthUrlResponse,
  GetJiraProjectsResponse,
  GetJiraSessionBacklogFieldsRequest,
  GetJiraSessionBacklogFieldsResponse,
  GetJiraSessionTeamFieldMappingFormattedResponse,
  GetJiraSessionTeamFieldMappingResponse,
  GetJiraSprintResponse,
  GetJiraSprintsResponse,
  GetJiraSyncSessionResponse,
  GetJiraTeamDefaultFieldsRequest,
  GetJiraTeamDefaultFieldsResponse,
  GetJiraTeamMappingFieldsRequest,
  GetJiraTeamMappingFieldsResponse,
  GetJiraTeamMappingSourcesFormattedResponse,
  GetJiraUsernameResponse,
  GetJiraWebhookEndpointResponse,
  NoData,
  SetJiraArtFieldMappingFromFormattedRequest,
  SetJiraArtFieldMappingRequest,
  SetJiraArtMappingSourcesRequest,
  SetJiraArtTeamFieldMappingFromFormattedRequest,
  SetJiraArtTeamFieldMappingRequest,
  SetJiraAuthMethodRequest,
  SetJiraBoardMappingRequest,
  SetJiraCustomEpicIssueTypeRequest,
  SetJiraKanbanBoardRequest,
  SetJiraPasswordRequest,
  SetJiraServiceAccountTokenRequest,
  SetJiraSessionTeamFieldMappingFromFormattedRequest,
  SetJiraSessionTeamFieldMappingRequest,
  SetJiraTeamMappingSourcesFromFormattedRequest,
  SetJiraUsernameRequest,
} from "./models";
import {
  canConnectResponseSchema,
  checkAllJiraProjectPermissionsForArtResponseSchema,
  checkJiraIssueTypeFieldsResponseSchema,
  checkJiraIssueTypeForArtsResponseSchema,
  checkJiraLinkTypeResponseSchema,
  checkJiraProjectPermissionsForArtResponseSchema,
  checkJiraProjectPermissionsResponseSchema,
  checkJiraTeamMappingsResponseSchema,
  createJiraSyncSessionResponseSchema,
  createJiraTestIssueResponseSchema,
  getJiraArtFieldMappingFormattedResponseSchema,
  getJiraArtFieldMappingResponseSchema,
  getJiraArtTeamFieldMappingFieldsResponseSchema,
  getJiraArtTeamFieldMappingFormattedResponseSchema,
  getJiraArtTeamFieldMappingResponseSchema,
  getJiraAuthMethodResponseSchema,
  getJiraBoardMappingResponseSchema,
  getJiraCustomEpicIssueTypeResponseSchema,
  getJiraEpicIssueTypeResponseSchema,
  getJiraFieldsResponseSchema,
  getJiraIssueLinkTypesResponseSchema,
  getJiraIssueTypesResponseSchema,
  getJiraKanbanBoardResponseSchema,
  getJiraKanbanConfigsResponseSchema,
  getJiraOAuthConsumerKeyResponseSchema,
  getJiraOAuthPublicKeyResponseSchema,
  getJiraOAuthUrlResponseSchema,
  getJiraProjectsResponseSchema,
  getJiraSessionBacklogFieldsResponseSchema,
  getJiraSessionTeamFieldMappingFormattedResponseSchema,
  getJiraSessionTeamFieldMappingResponseSchema,
  getJiraSprintResponseSchema,
  getJiraSprintsResponseSchema,
  getJiraSyncSessionResponseSchema,
  getJiraTeamDefaultFieldsResponseSchema,
  getJiraTeamMappingFieldsResponseSchema,
  getJiraTeamMappingSourcesFormattedResponseSchema,
  getJiraUsernameResponseSchema,
  getJiraWebhookEndpointResponseSchema,
  noDataSchema,
} from "./schemas";

export class AlmconnectionJiraApiClient {
  constructor(private caller: ApiCaller) {}

  async getJiraOauthUrl(
    payload: GetJiraOAuthUrlRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraOAuthUrlResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.oauth.url.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraOauthUrl",
      payload,
      { schema: getJiraOAuthUrlResponseSchema, timeout },
    );
  }

  async getJiraOauthConsumerKey(
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraOAuthConsumerKeyResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.oauth.consumer_key.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraOauthConsumerKey",
      {},
      { schema: getJiraOAuthConsumerKeyResponseSchema, timeout },
    );
  }

  async getJiraOauthPublicKey(timeout?: number): Promise<GetJiraOAuthPublicKeyResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.oauth.public_key.get",
        variables: {},
      },
      "getJiraOauthPublicKey",
      {},
      { schema: getJiraOAuthPublicKeyResponseSchema, timeout },
    );
  }

  async finishJiraOauth(
    payload: FinishJiraOAuthRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.oauth.finish",
        variables: { connectionId: String(connectionId) },
      },
      "finishJiraOauth",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraUsername(connectionId: string, timeout?: number): Promise<GetJiraUsernameResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.username.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraUsername",
      {},
      { schema: getJiraUsernameResponseSchema, timeout },
    );
  }

  async setJiraUsername(
    payload: SetJiraUsernameRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.username.set",
        variables: { connectionId: String(connectionId) },
      },
      "setJiraUsername",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async setJiraPassword(
    payload: SetJiraPasswordRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.password.set",
        variables: { connectionId: String(connectionId) },
      },
      "setJiraPassword",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraAuthMethod(
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraAuthMethodResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.auth_method.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraAuthMethod",
      {},
      { schema: getJiraAuthMethodResponseSchema, timeout },
    );
  }

  async setJiraAuthMethod(
    payload: SetJiraAuthMethodRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.auth_method.set",
        variables: { connectionId: String(connectionId) },
      },
      "setJiraAuthMethod",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async setJiraServiceAccountToken(
    payload: SetJiraServiceAccountTokenRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.service_account_token.set",
        variables: { connectionId: String(connectionId) },
      },
      "setJiraServiceAccountToken",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraWebhookEndpoint(
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraWebhookEndpointResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.webhook_endpoint.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraWebhookEndpoint",
      {},
      { schema: getJiraWebhookEndpointResponseSchema, timeout },
    );
  }

  async canConnect(connectionId: string, timeout?: number): Promise<CanConnectResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.can_connect.get",
        variables: { connectionId: String(connectionId) },
      },
      "canConnect",
      {},
      { schema: canConnectResponseSchema, timeout },
    );
  }

  async getJiraBoardMapping(
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraBoardMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.board_mapping.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraBoardMapping",
      {},
      { schema: getJiraBoardMappingResponseSchema, timeout },
    );
  }

  async setJiraBoardMapping(
    payload: SetJiraBoardMappingRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.board_mapping.set",
        variables: { connectionId: String(connectionId) },
      },
      "setJiraBoardMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraTeamMappingSourcesFormatted(
    connectionId: string,
    teamId: number,
    timeout?: number,
  ): Promise<GetJiraTeamMappingSourcesFormattedResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.teams.${teamId}.mapping_sources_formatted.get",
        variables: { connectionId: String(connectionId), teamId: String(teamId) },
      },
      "getJiraTeamMappingSourcesFormatted",
      {},
      { schema: getJiraTeamMappingSourcesFormattedResponseSchema, timeout },
    );
  }

  async setJiraTeamMappingSourcesFromFormatted(
    payload: SetJiraTeamMappingSourcesFromFormattedRequest,
    connectionId: string,
    teamId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.teams.${teamId}.mapping_sources_formatted.set",
        variables: { connectionId: String(connectionId), teamId: String(teamId) },
      },
      "setJiraTeamMappingSourcesFromFormatted",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async setJiraArtMappingSources(
    payload: SetJiraArtMappingSourcesRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.mapping_sources.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setJiraArtMappingSources",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraTeamMappingFields(
    payload: GetJiraTeamMappingFieldsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraTeamMappingFieldsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.team_mapping_fields.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraTeamMappingFields",
      payload,
      { schema: getJiraTeamMappingFieldsResponseSchema, timeout },
    );
  }

  async getJiraTeamDefaultFields(
    payload: GetJiraTeamDefaultFieldsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraTeamDefaultFieldsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.team_default_fields.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraTeamDefaultFields",
      payload,
      { schema: getJiraTeamDefaultFieldsResponseSchema, timeout },
    );
  }

  async getJiraArtTeamFieldMappingFields(
    payload: GetJiraArtTeamFieldMappingFieldsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraArtTeamFieldMappingFieldsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.art_team_field_mapping_fields.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraArtTeamFieldMappingFields",
      payload,
      { schema: getJiraArtTeamFieldMappingFieldsResponseSchema, timeout },
    );
  }

  async getJiraSessionBacklogFields(
    payload: GetJiraSessionBacklogFieldsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraSessionBacklogFieldsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.session_backlog_fields.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraSessionBacklogFields",
      payload,
      { schema: getJiraSessionBacklogFieldsResponseSchema, timeout },
    );
  }

  async getJiraCustomEpicIssueType(
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraCustomEpicIssueTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.custom_epic_issue_type.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraCustomEpicIssueType",
      {},
      { schema: getJiraCustomEpicIssueTypeResponseSchema, timeout },
    );
  }

  async setJiraCustomEpicIssueType(
    payload: SetJiraCustomEpicIssueTypeRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.custom_epic_issue_type.set",
        variables: { connectionId: String(connectionId) },
      },
      "setJiraCustomEpicIssueType",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraArtTeamFieldMapping(
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetJiraArtTeamFieldMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.team_field_mapping.get",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "getJiraArtTeamFieldMapping",
      {},
      { schema: getJiraArtTeamFieldMappingResponseSchema, timeout },
    );
  }

  async getJiraArtTeamFieldMappingFormatted(
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetJiraArtTeamFieldMappingFormattedResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.team_field_mapping_formatted.get",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "getJiraArtTeamFieldMappingFormatted",
      {},
      { schema: getJiraArtTeamFieldMappingFormattedResponseSchema, timeout },
    );
  }

  async setJiraArtTeamFieldMapping(
    payload: SetJiraArtTeamFieldMappingRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.team_field_mapping.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setJiraArtTeamFieldMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async setJiraArtTeamFieldMappingFromFormatted(
    payload: SetJiraArtTeamFieldMappingFromFormattedRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.team_field_mapping_formatted.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setJiraArtTeamFieldMappingFromFormatted",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraArtFieldMapping(
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetJiraArtFieldMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.field_mapping.get",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "getJiraArtFieldMapping",
      {},
      { schema: getJiraArtFieldMappingResponseSchema, timeout },
    );
  }

  async getJiraArtFieldMappingFormatted(
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetJiraArtFieldMappingFormattedResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.field_mapping_formatted.get",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "getJiraArtFieldMappingFormatted",
      {},
      { schema: getJiraArtFieldMappingFormattedResponseSchema, timeout },
    );
  }

  async setJiraArtFieldMapping(
    payload: SetJiraArtFieldMappingRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.field_mapping.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setJiraArtFieldMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async setJiraArtFieldMappingFromFormatted(
    payload: SetJiraArtFieldMappingFromFormattedRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.field_mapping_formatted.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setJiraArtFieldMappingFromFormatted",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraSessionTeamFieldMapping(
    sessionId: string,
    timeout?: number,
  ): Promise<GetJiraSessionTeamFieldMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.sessions.${sessionId}.team_field_mapping.get",
        variables: { sessionId: String(sessionId) },
      },
      "getJiraSessionTeamFieldMapping",
      {},
      { schema: getJiraSessionTeamFieldMappingResponseSchema, timeout },
    );
  }

  async getJiraSessionTeamFieldMappingFormatted(
    sessionId: string,
    timeout?: number,
  ): Promise<GetJiraSessionTeamFieldMappingFormattedResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.sessions.${sessionId}.team_field_mapping_formatted.get",
        variables: { sessionId: String(sessionId) },
      },
      "getJiraSessionTeamFieldMappingFormatted",
      {},
      { schema: getJiraSessionTeamFieldMappingFormattedResponseSchema, timeout },
    );
  }

  async setJiraSessionTeamFieldMapping(
    payload: SetJiraSessionTeamFieldMappingRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.sessions.${sessionId}.team_field_mapping.set",
        variables: { sessionId: String(sessionId) },
      },
      "setJiraSessionTeamFieldMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async setJiraSessionTeamFieldMappingFromFormatted(
    payload: SetJiraSessionTeamFieldMappingFromFormattedRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.sessions.${sessionId}.team_field_mapping_formatted.set",
        variables: { sessionId: String(sessionId) },
      },
      "setJiraSessionTeamFieldMappingFromFormatted",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async createJiraSyncSession(
    payload: CreateJiraSyncSessionRequest,
    connectionId: string,
    piSessionId: string,
    timeout?: number,
  ): Promise<CreateJiraSyncSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.pi_sessions.${piSessionId}.sync_session.create",
        variables: { connectionId: String(connectionId), piSessionId: String(piSessionId) },
      },
      "createJiraSyncSession",
      payload,
      { schema: createJiraSyncSessionResponseSchema, timeout },
    );
  }

  async getJiraSyncSession(
    connectionId: string,
    piSessionId: string,
    timeout?: number,
  ): Promise<GetJiraSyncSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.pi_sessions.${piSessionId}.sync_session.get",
        variables: { connectionId: String(connectionId), piSessionId: String(piSessionId) },
      },
      "getJiraSyncSession",
      {},
      { schema: getJiraSyncSessionResponseSchema, timeout },
    );
  }

  async checkJiraTeamMappings(
    payload: CheckJiraTeamMappingsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<CheckJiraTeamMappingsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.team_mappings_status.get",
        variables: { connectionId: String(connectionId) },
      },
      "checkJiraTeamMappings",
      payload,
      { schema: checkJiraTeamMappingsResponseSchema, timeout },
    );
  }

  async checkAllJiraProjectPermissionsForArt(
    payload: CheckAllJiraProjectPermissionsForArtRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<CheckAllJiraProjectPermissionsForArtResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.art_mappings_permissions_status.get",
        variables: { connectionId: String(connectionId) },
      },
      "checkAllJiraProjectPermissionsForArt",
      payload,
      { schema: checkAllJiraProjectPermissionsForArtResponseSchema, timeout },
    );
  }

  async checkJiraProjectPermissions(
    connectionId: string,
    projectId: string,
    timeout?: number,
  ): Promise<CheckJiraProjectPermissionsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.projects.${projectId}.permissions_status.get",
        variables: { connectionId: String(connectionId), projectId: String(projectId) },
      },
      "checkJiraProjectPermissions",
      {},
      { schema: checkJiraProjectPermissionsResponseSchema, timeout },
    );
  }

  async checkJiraProjectPermissionsForArt(
    connectionId: string,
    projectId: string,
    timeout?: number,
  ): Promise<CheckJiraProjectPermissionsForArtResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.projects.${projectId}.art_permissions_status.get",
        variables: { connectionId: String(connectionId), projectId: String(projectId) },
      },
      "checkJiraProjectPermissionsForArt",
      {},
      { schema: checkJiraProjectPermissionsForArtResponseSchema, timeout },
    );
  }

  async createJiraTestIssue(
    payload: CreateJiraTestIssueRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<CreateJiraTestIssueResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.test_issue.create",
        variables: { connectionId: String(connectionId) },
      },
      "createJiraTestIssue",
      payload,
      { schema: createJiraTestIssueResponseSchema, timeout },
    );
  }

  async createJiraTestIssueFromClientFormat(
    payload: CreateJiraTestIssueFromClientFormatRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<CreateJiraTestIssueResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.test_issue_from_client_format.create",
        variables: { connectionId: String(connectionId) },
      },
      "createJiraTestIssueFromClientFormat",
      payload,
      { schema: createJiraTestIssueResponseSchema, timeout },
    );
  }

  async getJiraKanbanConfigs(
    payload: GetJiraKanbanConfigsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraKanbanConfigsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.kanban_configs.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraKanbanConfigs",
      payload,
      { schema: getJiraKanbanConfigsResponseSchema, timeout },
    );
  }

  async getJiraArtKanbanBoard(
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetJiraKanbanBoardResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.kanban_board.get",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "getJiraArtKanbanBoard",
      {},
      { schema: getJiraKanbanBoardResponseSchema, timeout },
    );
  }

  async setJiraArtKanbanBoard(
    payload: SetJiraKanbanBoardRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.arts.${artId}.kanban_board.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setJiraArtKanbanBoard",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraProjects(connectionId: string, timeout?: number): Promise<GetJiraProjectsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.projects.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraProjects",
      {},
      { schema: getJiraProjectsResponseSchema, timeout },
    );
  }

  async getJiraIssueTypes(
    payload: GetJiraIssueTypesRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraIssueTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.issue_types.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraIssueTypes",
      payload,
      { schema: getJiraIssueTypesResponseSchema, timeout },
    );
  }

  async getJiraEpicIssueType(
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraEpicIssueTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.epic_issue_type.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraEpicIssueType",
      {},
      { schema: getJiraEpicIssueTypeResponseSchema, timeout },
    );
  }

  async getJiraFields(
    payload: GetJiraFieldsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraFieldsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.fields.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraFields",
      payload,
      { schema: getJiraFieldsResponseSchema, timeout },
    );
  }

  async getJiraIssueLinkTypes(
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraIssueLinkTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.issue_link_types.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraIssueLinkTypes",
      {},
      { schema: getJiraIssueLinkTypesResponseSchema, timeout },
    );
  }

  async getJiraSprint(
    connectionId: string,
    sprintId: number,
    timeout?: number,
  ): Promise<GetJiraSprintResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.sprints.${sprintId}.get",
        variables: { connectionId: String(connectionId), sprintId: String(sprintId) },
      },
      "getJiraSprint",
      {},
      { schema: getJiraSprintResponseSchema, timeout },
    );
  }

  async getJiraSprints(
    connectionId: string,
    boardId: number,
    timeout?: number,
  ): Promise<GetJiraSprintsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.boards.${boardId}.sprints.get",
        variables: { connectionId: String(connectionId), boardId: String(boardId) },
      },
      "getJiraSprints",
      {},
      { schema: getJiraSprintsResponseSchema, timeout },
    );
  }

  async checkJiraIssueTypeFields(
    payload: CheckJiraIssueTypeFieldsRequest,
    connectionId: string,
    issueTypeId: string,
    timeout?: number,
  ): Promise<CheckJiraIssueTypeFieldsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.issue_types.${issueTypeId}.fields_status.get",
        variables: { connectionId: String(connectionId), issueTypeId: String(issueTypeId) },
      },
      "checkJiraIssueTypeFields",
      payload,
      { schema: checkJiraIssueTypeFieldsResponseSchema, timeout },
    );
  }

  async checkJiraIssueTypeForArts(
    payload: CheckJiraIssueTypeForArtsRequest,
    connectionId: string,
    issueTypeId: string,
    timeout?: number,
  ): Promise<CheckJiraIssueTypeForArtsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.issue_types.${issueTypeId}.arts_status.get",
        variables: { connectionId: String(connectionId), issueTypeId: String(issueTypeId) },
      },
      "checkJiraIssueTypeForArts",
      payload,
      { schema: checkJiraIssueTypeForArtsResponseSchema, timeout },
    );
  }

  async checkJiraLinkType(
    payload: CheckJiraLinkTypeRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<CheckJiraLinkTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.jira.connections.${connectionId}.link_type_status.get",
        variables: { connectionId: String(connectionId) },
      },
      "checkJiraLinkType",
      payload,
      { schema: checkJiraLinkTypeResponseSchema, timeout },
    );
  }
}
